import { useCallback, useMemo } from 'react';
import { isPositiveAndFiniteNumber } from '../themes/disona/utils';

export const useProfitFactor = ({ absoluteLimitOfInvestment, store }) => {
  const onChange = useCallback(
    (value) => {
      const maxProfit = value * absoluteLimitOfInvestment.value;
      if (value > 0) {
        store.setCloseAtProfitOf(maxProfit);
        store.setCloseAtProfit(true);
      } else {
        store.setCloseAtProfit(false);
        store.setCloseAtProfitOf(0);
      }
    },
    [store, absoluteLimitOfInvestment.value]
  );

  const value = useMemo(() => {
    const calculationProfit =
      store.closeAtProfitOf / absoluteLimitOfInvestment.value;

    return store.closeAtProfit
      ? isPositiveAndFiniteNumber(calculationProfit)
        ? calculationProfit
        : 0
      : 0;
  }, [
    store.closeAtProfit,
    store.closeAtProfitOf,
    absoluteLimitOfInvestment.value,
  ]);

  return {
    onChange,
    value,
    enabled: store.closeAtProfit && !store.stopLossLevel,
  };
};
